module.exports = __webpack_public_path__ + "img/ws.07f7b455.svg";